type HTMLTagName = keyof JSX.IntrinsicElements

type TagConfig = {
  WrapperTag: HTMLTagName
  ItemTag: HTMLTagName
}

export const HTMLTagsForHowTo = {
  accordion: (isHowToAccordion: boolean): TagConfig => ({
    WrapperTag: isHowToAccordion ? 'ol' : 'fieldset',
    ItemTag: isHowToAccordion ? 'li' : 'div',
  }),
  nColGrid: (isHowToNColGrid: boolean): TagConfig => ({
    WrapperTag: isHowToNColGrid ? 'ol' : 'div',
    ItemTag: isHowToNColGrid ? 'li' : 'div',
  }),
  nStep: (isHowToNStep: boolean): TagConfig => ({
    WrapperTag: isHowToNStep ? 'ol' : 'fieldset',
    ItemTag: isHowToNStep ? 'li' : 'div',
  }),
}
